export enum PreferenceType {
  ConfirmationPhone = 'confirmation_phone',
  ConfirmationSms = 'confirmation_sms',
  ConfirmationEmail = 'confirmation_email',
  ConfirmationDaysPrior = 'confirmation_days_prior',
  ReminderSms = 'reminder_sms',
  ReminderEmail = 'reminder_email',
  SchAasPreRecWeekMask = 'sch_aas_pref_rec_week_mask',
  SchAasPreferredTod = 'sch_aas_preferred_tod',
  ReceiptsInvPrint = 'receipts_inv_print',
  ReceiptsInvSms = 'receipts_inv_sms',
  ReceiptsInvEmial = 'receipts_inv_email',
  PrimaryPhone = 'primary_phone',
  MarketingPromoSms = 'marketing_promo_sms',
  MarketingPromoEmail = 'marketing_promo_email'
}

export type PreferencesFormType = {
  [kee in PreferenceType]: number;
};

export interface SimpleItemInterface {
  label: string;
  value: string | number;
}

export interface ItemInterface extends SimpleItemInterface {
  key: PreferenceType;
}

export interface CheckboxStateInterface {
  opt1: boolean;
  opt2: boolean;
}

export type CheckboxFieldsType = keyof CheckboxStateInterface;

export interface VariantCheckboxItem {
  value: boolean;
  label: string;
  onChange: (newValue: boolean) => void;
  id: number;
}
